import type { AppWorkspace, User } from '../api'
import { ROUTES } from './nav'

/** Server fields win; the role fallback keeps additive rollout compatible with
 * older API responses. This projection selects UI only and grants nothing. */
export function workspacesFor(user: User | null | undefined): AppWorkspace[] {
  if (!user) return []
  if (user.workspaces) return user.workspaces
  if (user.role === 'installer') return ['installer']
  if (user.role === 'homeowner') return ['homeowner']
  return []
}

export function defaultWorkspaceFor(user: User | null | undefined): AppWorkspace | undefined {
  if (!user) return undefined
  if (user.defaultWorkspace && workspacesFor(user).includes(user.defaultWorkspace)) return user.defaultWorkspace
  return user.role === 'installer' ? 'installer' : user.role === 'homeowner' ? 'homeowner' : undefined
}

export function canUseWorkspace(user: User | null | undefined, workspace: AppWorkspace): boolean {
  return workspacesFor(user).includes(workspace)
}

/** The one post-auth and failed-deep-link destination resolver (APP-ACC-10). */
export function defaultRouteFor(user: User | null | undefined): string {
  if (!user) return ROUTES.login
  if (user.role === 'admin') return ROUTES.adminPortal
  if (user.role === 'support') return ROUTES.supportConsole
  return defaultWorkspaceFor(user) === 'installer' ? ROUTES.fleet : ROUTES.home
}
